import { setElementVars } from "@vanilla-extract/dynamic"
import { useEffect } from "react"
import * as styles from "./lockBodyScroll.css"

let leftShift = 0
let rightShift = 0
function setupNoScroll() {
	let oldBodyClientRect = document.body.getBoundingClientRect()
	document.body.classList.add(styles.noScroll)
	let newBodyClientRect = document.body.getBoundingClientRect()
	leftShift = oldBodyClientRect.left - newBodyClientRect.left
	rightShift = newBodyClientRect.right - oldBodyClientRect.right
	// Sometimes, the body's width changes when we add the noScroll class.
	// This is because the scrollbar is hidden, so the body's width is
	// increased to compensate. We need to account for this to avoid a
	// jarring jump.
	setElementVars(document.body, {
		[styles.noScrollLeftShift]: `${leftShift}px`,
		[styles.noScrollRightShift]: `${rightShift}px`,
	})
}

function teardownNoScroll() {
	document.body.classList.remove(styles.noScroll)
	setElementVars(document.body, {
		[styles.noScrollLeftShift]: "",
		[styles.noScrollRightShift]: "",
	})
}

const locks = new Set<symbol>()
export function lockBodyScroll() {
	const lock = Symbol("body scroll lock")
	locks.add(lock)
	if (locks.size === 1) setupNoScroll()
	return () => {
		let lockWasRemoved = locks.delete(lock)
		if (lockWasRemoved && locks.size === 0) teardownNoScroll()
	}
}

// Prevents the body from scrolling when the modal is open.
// This is done by adding a class to the body that sets overflow: hidden.
// Because in theory multiple modals could be open at once, we keep a count
// of how many modals are open and only remove the class when the last one is
// closed.
export function useLockedBodyScroll(isLocked: boolean = true) {
	useEffect(() => {
		if (!isLocked) return
		const unlock = lockBodyScroll()
		return () => {
			unlock()
		}
	}, [isLocked])
}
